import { Bot, FileText, UserCheck, type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import type { DeployMode } from "../../../types/strategyDeploy";
import { statsCardHeadlineClassName } from "../Statistics/components/statisticsCardHeadline";
import { statisticsShadcnCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

/** Launchpad cards: the Statistics card shell with its 1px stroke forced (the Chakra reset strips
 *  borders from plain elements). Pair with `liveCardBodyClassName` for the standard padding. */
export const liveCardClassName = cn(statisticsShadcnCardClassName, "!border !border-solid !border-border");

/** Standard card padding and inner spacing. */
export const liveCardBodyClassName = "gap-4 p-5";

/** Card titles: the Statistics chart-card title (uppercase, muted, text-sm). */
export const liveCardTitleClassName =
  "m-0 font-[family-name:var(--font-primary)] text-sm font-medium uppercase text-muted-foreground dark:!text-white";

/** Section / setting titles: brand Tropical Surf. */
export const liveSectionTitleClassName =
  "m-0 font-[family-name:var(--font-primary)] text-base font-medium text-[color:var(--brand-tropical-surf)]";

/** Option / row titles inside cards (settings rows, wizard options). */
export const liveOptionTitleClassName =
  "font-[family-name:var(--font-primary)] text-sm font-medium text-[color:var(--brand-tropical-surf)]";

export const livePageTitleClassName =
  "font-[family-name:var(--font-primary)] text-2xl font-normal text-[color:var(--brand-tropical-surf)] md:text-3xl";

/** Stat / column labels: the Statistics card headline (uppercase, muted). */
export const liveLabelClassName = statsCardHeadlineClassName;

/** Body copy: muted gray in light mode, white in dark mode. Never black. */
export const liveBodyTextClassName =
  "font-[family-name:var(--font-primary)] text-sm leading-relaxed text-gray-500 dark:text-white";

export const liveSmallTextClassName =
  "font-[family-name:var(--font-primary)] text-xs leading-relaxed text-gray-500 dark:text-white";

/** Field labels in forms. */
export const liveFieldLabelClassName =
  "font-[family-name:var(--font-primary)] text-xs font-medium text-gray-500 dark:text-white";

/** Figures: IBM Plex Sans, tabular, muted gray (signed values get the P&L colour inline). */
export const liveFigureClassName = "font-ibm-plex text-sm font-medium tabular-nums text-gray-600 dark:text-white";

/** Nested rows / insets inside a card (settings rows, review blocks). */
export const liveInsetClassName = "flex min-w-0 flex-col rounded-[6px] !border !border-solid !border-border";

/** Paper, Copilot, Autopilot: one icon set everywhere on the Launchpad. */
export const MODE_ICON: Record<DeployMode, LucideIcon> = { paper: FileText, approve: UserCheck, auto: Bot };
